import { render, staticRenderFns } from "./PaywallOverlay.vue?vue&type=template&id=24a26a8c&scoped=true"
import script from "./PaywallOverlay.vue?vue&type=script&lang=js"
export * from "./PaywallOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a26a8c",
  null
  
)

export default component.exports